import { db, storage } from "../firebase_setup/firebase";
import { getCountFromServer,
        collection,
        deleteDoc,
        orderBy,
        getDocs,
        setDoc,
        getDoc,
        query,
        where,
        doc } from "firebase/firestore";
import { getDownloadURL,
        deleteObject,
        getMetadata,
        uploadBytes,
        ref } from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';



export const genUUID = () => {
    return uuidv4();
};



// Categories functions
export const getCategoriesList = async () => {
	try {
        let data = [];
        const resp = await getDocs(query(collection(db, "PromCategories"), orderBy('descripcion')));

        resp.forEach((doc) => {
            data.push({
                'uuid': doc.id,
                'descripcion': doc.data()['descripcion']
            });
        });

        return { message: "OK", data: data };
	} catch (error) {
		return { message: "ERROR", data: error };
	}
};

export const getCategory = async (pk) => {
    try {
        const docSnap = await getDoc(doc(db, "PromCategories", pk));

        if (docSnap.exists()) {
            return { message: "OK", data: { 'uuid': docSnap.id,
                                            'descripcion': docSnap.data()['descripcion'] } };
        } else {
            return { message: "ERROR", data: {} };
        }
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const setCategory = async (data) => {
    try {
        await setDoc(doc(db, "PromCategories", data?.uuid), {
            descripcion: data?.descripcion
        });

        return { message: "OK", data: {} };

    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const delCategory = async (pk) => {
    try {
        await deleteDoc(doc(db, "PromCategories", pk));
        return { message: "OK", data: {} };
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};



// Storage functions
const uploadAllImages = async (pk, imagesArray) => {
    let arrCurImgs = [];
    const actualArticle = await getArticle(pk);

    if (actualArticle?.message?.toUpperCase() === 'OK') {
        arrCurImgs = actualArticle?.data?.images;
    };

    arrCurImgs.map(async (el) => {
        const elm = imagesArray.filter((i) => i.url === el.url);
        if (elm.length === 0) {
            try {
                await deleteObject(ref(storage, el.url));
            } catch (error) {
                console.error("Error al eliminar:", error.message);
            };
        };
    });

    const uploadPromises = imagesArray.map(async (img) => {
        if (img.file) {
            const storageRef = ref(storage, `images/${img.file.name}`);
            await uploadBytes(storageRef, img.file);
            return getDownloadURL(storageRef);
        } else {
            return img.url;
        };
    });

    const urls = await Promise.all(uploadPromises);
    return urls;
};

const getImageInfo = async (arr) => {
    try {
        const getInfo = arr.map(async (el) => {
            return { 'url': el,
                     'type': (await getMetadata(ref(storage, el))).contentType };
        });

        const data = await Promise.all(getInfo);
        return data;
    } catch (err) {
        console.error('Se presento un error al procesar los metadatos de las imagenes del artículo. Error :>> ', err);
        return [];
    }
};



// Articles functions
export const getProductPublicList = async () => {
    try {
        let data = [];
        const resp = await getDocs(query(collection(db, "promotionals"), where("estatus", 'in', ['en_venta', 'vendido']), orderBy('descripcion_corta')));

        resp.forEach(async (doc) => {
            let img = [];
            doc.data()['images'].forEach((ig) => {
                img.push({'url': ig});
            });

            data.push({
                'uuid': doc.id,
                'descripcion_corta': doc.data()['descripcion_corta'],
                'descripcion_larga': doc.data()['descripcion_larga'],
                'estatus': doc.data()['estatus'],
                'precio_venta': doc.data()['precio_venta'],
                'piezas': doc.data()['piezas'],
                'vendidos': doc.data()['vendidos'],
                'images': img
            });
        });

        return { message: "OK", data: data };
	} catch (error) {
		return { message: "ERROR", data: error };
	}
};

export const getPublicProductItem = async (pk) => {
    try {
        let data = [];
        const docSnap = await getDoc(doc(db, "promotionals", pk));

        if (docSnap.exists()) {
            data.push({
                'uuid': docSnap.id,
                'descripcion_corta': docSnap.data()['descripcion_corta'],
                'descripcion_larga': docSnap.data()['descripcion_larga'],
                'marca': docSnap.data()['marca'],
                'modelo': docSnap.data()['modelo'],
                'costo_adquisicion': docSnap.data()['costo_adquisicion'],
                'precio_venta': docSnap.data()['precio_venta'],
                'piezas': docSnap.data()['piezas'],
                'vendidos': docSnap.data()['vendidos'],
                'estado_fisico__uuid': docSnap.data()['estado_fisico__uuid'],
                'estatus': docSnap.data()['estatus'],
                'images': await getImageInfo(docSnap.data()['images'])
            });

            return { message: "OK", data: data };
        } else {
            return { message: "ERROR", data: {} };
        }
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const getProductAdminList = async () => {
    try {
        let data = [];
        const resp = await getDocs(query(collection(db, "promotionals"), orderBy('descripcion_corta')));

        resp.forEach((doc) => {
            let img = [];
            doc.data()['images'].forEach((ig) => {
                img.push({'url': ig});
            });

            data.push({
                'uuid': doc.id,
                'descripcion_corta': doc.data()['descripcion_corta'],
                'descripcion_larga': doc.data()['descripcion_larga'],
                'estatus': doc.data()['estatus'],
                'precio_venta': doc.data()['precio_venta'],
                'piezas': doc.data()['piezas'],
                'vendidos': doc.data()['vendidos'],
                'images': img
            });
        });

        return { message: "OK", data: data };
	} catch (error) {
		return { message: "ERROR", data: error };
	}
};

export const getAdminProductItem = async (pk) => {
    try {
        let data = [];
        const docSnap = await getDoc(doc(db, "promotionals", pk));

        if (docSnap.exists()) {
            data.push({
                'uuid': docSnap.id,
                'descripcion_corta': docSnap.data()['descripcion_corta'],
                'descripcion_larga': docSnap.data()['descripcion_larga'],
                'marca': docSnap.data()['marca'],
                'modelo': docSnap.data()['modelo'],
                'n_serie': docSnap.data()['n_serie'],
                'fecha_adquisicion': docSnap.data()['fecha_adquisicion'],
                'costo_adquisicion': docSnap.data()['costo_adquisicion'],
                'precio_venta': docSnap.data()['precio_venta'],
                'piezas': docSnap.data()['piezas'],
                'vendidos': docSnap.data()['vendidos'],
                'estado_fisico__uuid': docSnap.data()['estado_fisico__uuid'],
                'estatus': docSnap.data()['estatus'],
                'images': await getImageInfo(docSnap.data()['images'])
            });

            return { message: "OK", data: data };
        } else {
            return { message: "ERROR", data: {} };
        }
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const getArticleList = async () => {
    try {
        let data = [];
        const resp = await getDocs(collection(db, "promotionals"), orderBy('descripcion_corta'));

        resp.forEach((doc) => {
            data.push({
                'uuid': doc.id,
                'descripcion_corta': doc.data()['descripcion_corta'],
                'estatus': doc.data()['estatus']
            });
        });

        return { message: "OK", data: data };
	} catch (error) {
		return { message: "ERROR", data: error };
	}
};

export const getArticle = async (pk) => {
    try {
        const docSnap = await getDoc(doc(db, "promotionals", pk));

        if (docSnap.exists()) {
            const data = { 'uuid': docSnap.id,
                            'descripcion_corta': docSnap.data()['descripcion_corta'],
                            'descripcion_larga': docSnap.data()['descripcion_larga'],
                            'categoria': docSnap.data()['categoria'],
                            'marca': docSnap.data()['marca'],
                            'modelo': docSnap.data()['modelo'],
                            'n_serie': docSnap.data()['n_serie'],
                            'fecha_adquisicion': docSnap.data()['fecha_adquisicion'],
                            'costo_adquisicion': docSnap.data()['costo_adquisicion'],
                            'precio_venta': docSnap.data()['precio_venta'],
                            'piezas': docSnap.data()['piezas'],
                            'vendidos': docSnap.data()['vendidos'],
                            'estado_fisico__uuid': docSnap.data()['estado_fisico__uuid'],
                            'estatus': docSnap.data()['estatus'],
                            'images': await getImageInfo(docSnap.data()['images'])
                        };

            return { message: "OK", data: data };
        } else {
            return { message: "ERROR", data: {} };
        }
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const setArticle = async (data) => {
    try {
        await setDoc(doc(db, "promotionals", data?.uuid), {
            descripcion_corta: data?.descripcion_corta,
            descripcion_larga: data?.descripcion_larga,
            categoria: data?.categoria,
            marca: data?.marca,
            modelo: data?.modelo,
            n_serie: data?.n_serie,
            fecha_adquisicion: data?.fecha_adquisicion,
            costo_adquisicion: data?.costo_adquisicion,
            precio_venta: data?.precio_venta,
            piezas: data?.piezas,
            vendidos: data?.vendidos || 0,
            estado_fisico__uuid: data?.estado_fisico__uuid,
            estatus: data?.estatus,
            images: []
        }, { merge: true });

        let imgUrls = [];
        if (data?.images && data?.images.length > 0) {
            try {
                imgUrls = await uploadAllImages(data?.uuid, data?.images);
            } catch (err) {
                return { message: "ERROR", data: err };
            }
        }

        if (imgUrls.length > 0){
            await setDoc(doc(db, "promotionals", data?.uuid), {
                images: imgUrls
            }, { merge: true });
        }

        return { message: "OK", data: {} };
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const delArticle = async (pk) => {
    try {
        const docSnap = await getDoc(doc(db, "promotionals", pk));

        if (docSnap.exists()) {
            try {
                if (docSnap.data()['images'].length > 0) {
                    docSnap.data()['images'].map(async (el) => {
                        try {
                            await deleteObject(ref(storage, el));
                        } catch (error) {
                            console.error("Error al eliminar:", error.message);
                        };
                    });
                };
            } catch {}

            await deleteDoc(doc(db, "promotionals", pk));
            return { message: "OK", data: {} };
        } else {
            return { message: "ERROR", data: 'Artículo no identificado.' };
        }
    } catch (error) {
		return { message: "ERROR", data: error };
    }
};

export const getTotalArticles = async () => {
    let totalProducts = 0;
    let totalInvestment = 0;

    try {
        const products = await getCountFromServer(query(collection(db, "promotionals"), where("estatus", "!=", "vendido")));
        totalProducts = products.data().count;
    } catch (err) {
        console.error('Error en recuperación del total de bienes :>>', err);
    }

    try {
        const investment = await getDocs(query(collection(db, 'articles'), where('estatus', '!=', "vendido")));
        investment.forEach((doc) => {
            totalInvestment += (parseFloat(doc.data()['piezas']) || 1) * (parseFloat(doc.data()['costo_adquisicion']) || 0);
        });
    } catch (err) {
        console.error('Error en recuperación del total de inversión :>>', err);
    }

    return { message: "OK", data: { 'totalProducts': totalProducts,
                                    'totalInvestment': totalInvestment } };
};
